import { spawn } from 'redux-saga/effects';
import { watchTargets } from './targets';

export function* targetsSaga() {
  yield spawn(watchTargets);
}
